import $ from 'jquery';
import Cache from 'root/cache';
import Router from 'root/router';
import Modals from 'root/modals';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'workspace-login',

    show_create: true,

    events: {
        'click .workspace-item'   : 'onSelectWorkspace',
        'click .workspace-create' : 'onCreateWorkspace'
    },

    dom_handlers: {
        onSelectWorkspace: function(e) {
            var workspace_id = $(e.currentTarget).data('val');

            if (workspace_id === Cache.default_workspace_id) {
                if ('https://' + window.location.host === Cache.workspace.get(workspace_id).getUrl()) {
                    this.trigger('login');
                    this.redirect('/project/');
                } else {
                    this.redirect(false, Cache.workspace.get(workspace_id).getUrl() + '/project/');
                }
            } else {
                Cache.app.setDefaultWorkspace(workspace_id, () => {
                    this.redirect(false, Cache.workspace.get(workspace_id).getUrl() + '/project/');
                });
            }
        },

        onCreateWorkspace: function(e) {
            Modals.createWorkspace();
        }
    },

    redirect: function(spa_url, redirect_url) {
        if (Cache.login_redirect === 'intercom_oauth') {
            window.location = Cache.app.configs.api_host + 'intercom/install';
        } else if (spa_url) {
            Router.navigate(spa_url, {trigger: true});
        } else if (redirect_url) {
            window.location = redirect_url;
        }
    },

    initialize: function(options) {
        this.show_create = !!options.show_create;
    },

    render: function() {
        var content =
        '<h3>Select a workspace to log in</h3>' +
        '<div class="margin-bottom-32">You\'ve signed in as <b>' + Cache.getRealUser().escape('email') + '</b></div>';

        Cache.workspace.each((model) => {
            content +=
            '<div class="workspace-item" data-val="' + model.id + '">' +
                '<div><img class="workspace-logo" src="' + (model.escape('logo_url') || '/image/logo_square.png') + '"></div>' +
                '<div>' +
                    '<div class="workspace-name">' +  Util.htmlEntities(model.getName()) + '</div>' +
                    '<div class="workspace-url">' + model.getUrl() + '</div>' +
                '</div>' +
            '</div>';
        });

        if (this.show_create) {
            content +=
            '<div class="hr"><span class="text-info">or</span></div>' +
            '<div class="workspace-create">' +
                '<i class="fa-regular fa-plus"></i>Create a workspace' +
            '</div>';
        }

        this.$el.html(content);

        return this;
    }
});